<template >
	<div >
		 <headertop></headertop>
		<!-- 头像-->
		<div class="main">
		  <br />
<!-- 		  <el-tabs tab-position="left" style="margin-top: 10px;">
		    <el-tab-pane label="基本信息"> -->
		      <!-- 头像-->
          <h3 style="color: red;">请先进行手机号及邮箱验证</h3>
		      <el-form ref="form" label-width="120px">
		        <el-form-item label="头像:">
		          <el-avatar :src="info.img"></el-avatar>
		          <el-upload class="right eidtbtn" ref="up_img"
		            action=""
		            accept="image/*"
		            drag
		            :auto-upload="false"
		            :show-file-list="false"
		            :on-change='change_img'>
		            上传图片
		          </el-upload>
		        </el-form-item>

		        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
		              <div class="cropper-content">
		                <div class="cropper" style="text-align:center">
		                <vueCropper
		                    ref="cropper"
		                    :img="option.img"
		                    :outputSize="option.size"
		                    :outputType="option.outputType"
		                    :info="true"
		                    :full="option.full"
		                    :canMove="option.canMove"
		                    :canMoveBox="option.canMoveBox"
		                    :original="option.original"
		                    :autoCrop="option.autoCrop"
		                    :fixed="option.fixed"
		                    :fixedNumber="option.fixedNumber"
		                    :centerBox="option.centerBox"
		                    :infoTrue="option.infoTrue"
		                    :fixedBox="option.fixedBox"
		                    style="height: 10rem;"
		                    :loading="option.loading"
		                  ></vueCropper>
		                </div>
		              </div>
		              <div slot="footer" class="dialog-footer">
		                <el-button @click="dialogVisible = false">取 消</el-button>
		                <el-button type="primary" @click="finish" :loading="option.loading">确认</el-button>
		              </div>
		            </el-dialog>


		        <el-form-item label="公司名称:">
		          <p>{{info.company}}</p>
		        </el-form-item>

		        <!-- 真实姓名-->
		        <el-form-item label="真实姓名:">
		          <p>{{info.rale_name}}</p>
		        </el-form-item>

		        <!-- 用户名-->
		        <el-form-item label="用户名:">
		          <p>{{info.name}}</p>
		          <el-button type="text" class="right eidtbtn" @click="edit_btn('name')">修改</el-button>
		          <br />
		          <div class="eidt" v-if="up_el_status.name">
		            <el-input v-model.trim="save_data.name" placeholder="用户名"></el-input>
		            <div class="right" >
		               <el-button size="small"  @click="up_el_status.name = false">取消</el-button>
		              <el-button type="primary" size="small" @click="save('name')">保存</el-button>
		            </div>
		          </div>
		        </el-form-item>

		        <!-- 邮箱-->
		        <el-form-item label="邮箱:">
		          <p>{{info.mail}}</p>
		          <el-button type="text" class="right eidtbtn" @click="edit_btn('mail')">验证或更换</el-button>
		          <br />
		          <div class="eidt" v-if="up_el_status.mail">
		            <el-input v-model.trim="save_data.mail" placeholder="邮箱"></el-input>
		            <div>
		              <el-input v-model.trim="save_data.mail_code" placeholder="验证码">
		                <el-button type="primary" slot="append" @click="send_code('mail')">{{up_el_status.mail_code_text}}</el-button>
		              </el-input>
		              <div class="right" >
		                 <el-button size="small"  @click="up_el_status.mail = false">取消</el-button>
		                <el-button type="primary" size="small" @click="save('mail')">保存</el-button>
		              </div>
		            </div>
		          </div>
              <span>
                提示:<br>
                (1)个人邮箱：如若您未收到邮箱提示，请前往垃圾邮箱进行查看;若垃圾邮箱中也没有，请将rzex@email.zhiyaozhishi.com添加进您的邮箱白名单,再次获取验证邮箱
                <br>
                (2)企业邮箱:请先联系企业邮箱管理员将rzex@email.zhiyaozhishi.com添加至白名单，然后进行邮箱验证
              </span>
		        </el-form-item>

		        <!-- 手机号-->
		        <el-form-item label="手机号:">
		          <p>{{info.phone}}</p>
		          <el-button type="text" class="right eidtbtn" @click="edit_btn('phone')">验证或更换</el-button>
		          <br />
		          <div class="eidt" v-if="up_el_status.phone">
		            <el-input v-model.trim="save_data.phone" placeholder="手机号"></el-input>
		            <div>
		              <el-input v-model.trim="save_data.phone_code" placeholder="验证码">
		                <el-button type="primary" slot="append" @click="send_code('phone')">{{up_el_status.phone_code_text}}</el-button>
		              </el-input>
		              <div class="right" >
		                 <el-button size="small"  @click="up_el_status.phone = false">取消</el-button>
		                <el-button type="primary" size="small" @click="save('phone')">保存</el-button>
		              </div>
		            </div>
		          </div>
		        </el-form-item>
		      </el-form>
		</div>
		<footerbom></footerbom>
	</div>
</template>

<script>

	import Header from '../components/index/public/NavHeader.vue'
	import Footer from '../components/index/public/NavFooter.vue'
	import { VueCropper } from 'vue-cropper'
	 export default {
		data() {
		    return {
		      dialogVisible: false,
		            // 裁剪组件的基础配置option
		            option: {
		              img: '', // 裁剪图片的地址
		              info: true, // 裁剪框的大小信息
		              outputSize: 0.8, // 裁剪生成图片的质量
		              outputType: 'jpeg', // 裁剪生成图片的格式
		              canScale: false, // 图片是否允许滚轮缩放
		              autoCrop: true, // 是否默认生成截图框
		              // autoCropWidth: 300, // 默认生成截图框宽度
		              // autoCropHeight: 200, // 默认生成截图框高度
		              fixedBox: true, // 固定截图框大小 不允许改变
		              fixed: true, // 是否开启截图框宽高固定比例
		              fixedNumber: [5, 5], // 截图框的宽高比例
		              full: true, // 是否输出原图比例的截图
		              canMoveBox: false, // 截图框能否拖动
		              original: false, // 上传图片按照原始比例渲染
		              centerBox: true, // 截图框是否被限制在图片里面
		              infoTrue: true ,// true 为展示真实输出图片宽高 false 展示看到的截图框宽高
		              loading:false
		            },
		            picsList: [],  //页面显示的数组
		      /* 基本信息*/
		      info:{
		        company:'',
		        rale_name:'',
		        name:'',
		        img:'',
		        phone:'',
		        mail:'',
		      },
		      msg: {
		        list:[],
		        currentPage: 1, // 当前页码
		        total: 0, // 总条数
		        pageSize: 10,
		        msg_content:'消息内容',
		        centerDialogVisible:false,
		        search: '',
		        button_show:true,
		        selest_list:[],
		      },
		      up_el_status:{
		        name:false,
		        phone:false,
		        phone_code_text:'获取验证码',
		        mail:false,
		        mail_code_text:'获取验证码',
		        phone_last:60,
		        mail_last:60,
		        phone_timer:null,
		        mail_timer:null,
		      },
		      save_data:{
		        img:'',
		        name:'',
		        phone:'',
		        phone_code:'',
		        mail:'',
		        mail_code:'',
		        type:null,
		      },
		    }
		  },
		  components: {
		    headertop: Header,
		    footerbom: Footer,
		  },
		  mounted:function(){
        this.check_companyee_status()
		    this.get_info()
		    this.get_msg()
		  },
		  methods: {
        companyee_status_msg(msg){
          const h = this.$createElement;
          this.$notify({
            title: '绑定提示',
            message: h('b', { style: 'color: red'}, msg),
            duration: 0
          })
        },

        check_companyee_status(){
          let _this=this
          if(_this.$store.state.info.info_status.phone_status=='1'){
              if(_this.$store.state.info.info_status.mail_status=='1'){
                _this.$router.push({
                  path: '/home'
                })
              }else{
                _this.companyee_status_msg('邮箱未进行绑定或绑定失败')
              }
          }else{
            if(_this.$store.state.info.info_status.mail_status=='1'){
             _this.companyee_status_msg('手机号未进行绑定或绑定失败')
            }else{
              _this.companyee_status_msg('手机号、邮箱未进行绑定或绑定失败')
            }
          }
        },
		    change_img(event){
		      let _this=this
		      _this.$refs.up_img.clearFiles();
		    	// 获取上传图片的本地url，用于上传前的本地预览
		    	let url = '';
		      url = window.URL.createObjectURL(event.raw);
		    	if (window.createObjectURL != undefined) {
		    		url = window.createObjectURL(event.raw);
		    	} else if (window.URL != undefined) {
		    		url = window.URL.createObjectURL(event.raw);
		    	} else if (window.webkitURL != undefined) {
		    		url = window.webkitURL.createObjectURL(event.raw);
		    	}else{
		        url = window.webkitURL.createObjectURL(event.raw);
		      }
		      _this.$nextTick(() => {
		        _this.option.img = url;
		        _this.dialogVisible = true
		      })
		    },
		    finish(){
		      let _this=this
		      _this.$refs.cropper.getCropData((base64) => {
		        _this.save_data.img=base64
		        _this.save('img')
		      })
		    },
		    get_info(){
		      let _this=this;
		      _this.axios.get('/v2/user/get_info').then(function(res) {
		        if(res.status=='200'){
		          if(res.data.code=='1'){
		            _this.info=res.data.data
		          }else{
		            _this.$message.error(res.msg)
		          }
		        }else{
		          _this.$message.error('服务器内部错误')
		        }
		      }).catch(function(error) {
		        _this.$message.error('服务器内部错误')
		      });
		    },
		    edit_btn(el){
		      let _this=this;
		      _this.up_el_status[el]=!_this.up_el_status[el]
		    },
		    change_info_check(type){
		      let _this=this;
		      if(_this.up_el_status[type+'_timer'] == null) {
		        _this.up_el_status[type+'_timer'] = setInterval( () => {
		          if(_this.up_el_status[type+'_last']>0){
		            _this.up_el_status[type+'_code_text']=_this.up_el_status[type+'_last']+'s后重新获取';
		            _this.up_el_status[type+'_last']--;
		          }else{
		            clearInterval(_this.up_el_status[type+'_timer']);
		            _this.up_el_status[type+'_timer']=null;
		            _this.up_el_status[type+'_last']=60;
		            _this.up_el_status[type+'_code_text']='获取验证码';
		          }
		        }, 1000)
		      }
		    },
		    send_code(type){
		      let _this=this;
		      if(_this.up_el_status[type+'_code_text']!='获取验证码'){
		        return false;
		      }
		      _this.save_data.type=type
		      _this.axios.post('/v2/user/send_code', {
		        data: _this.save_data //注意post请求发送参数的方式和get请求方式是有区别的
		      }).then(function(res) {
		        if(res.status=='200'){
		          if(res.data.code=='1'){
		            _this.$message.success(res.data.msg);
		            _this.change_info_check(type);
		          }else{
		            _this.$message.error(res.data.msg);
		          }
		        }else{
		          _this.$message.error('服务器内部错误');
		        }
		      }).catch(function(error) {
		        _this.$message.error('服务器内部错误');
		      });
		    },
		    save(type){
		      let _this=this
		      _this.save_data.type=type
		      _this.axios.post('/v2/user/up', {
		        data: _this.save_data //注意post请求发送参数的方式和get请求方式是有区别的
		      }).then(function(res) {
		        if(res.status=='200'){
		          if(res.data.code=='1'){
		            switch(type){
		              case 'img':_this.dialogVisible = false;break
		              case 'name':_this.up_el_status.name  = false;break
		              case 'phone':_this.up_el_status.phone  = false;break;
		              case 'mail':_this.up_el_status.mail  = false;break;
		            }
		            _this.get_info()
		            _this.save_change(type)
		            _this.$message.success(res.data.msg)
		          }else{
		            _this.$message.error(res.data.msg)
		          }
		        }else{
		          _this.$message.error('服务器内部错误')
		        }
		      }).catch(function(error) {
		        _this.$message.error('服务器内部错误')
		      });
		    },
		    save_change(type){
		      let _this=this
		      if(type=='img'){
		        _this.save_data.img=''
		      }
		      if(type=='name'){
		        _this.save_data.name=''
		      }
		      if(type=='phone'){
            var new_info=_this.$store.state.info
            new_info.info_status.phone_status='1'
            _this.$store.commit('info_save', new_info)
		        _this.save_data.phone=''
		        _this.save_data.phone_code=''
		      }
		      if(type=='mail'){
            var new_info=_this.$store.state.info
            new_info.info_status.mail_status='1'
            _this.$store.commit('info_save', new_info)
		        _this.save_data.mail=''
		        _this.save_data.mail_code=''
		      }
		      if(type=='pwd'){
		        _this.save_data.old=''
		        _this.save_data.pwd=''
		        _this.save_data.pwd_re=''
		      }
		    },
		    get_msg(){
		      let _this=this;
		      _this.axios.get('/v2/user/get_msg').then(function(res) {
		        if(res.status=='200'){
		          if(res.data.code=='1'){
		            _this.msg.list=res.data.data
		            _this.msg.total=res.data.data.length
		          }else{
		            _this.$message.error(res.msg)
		          }
		        }else{
		          _this.$message.error('服务器内部错误')
		        }
		      }).catch(function(error) {
		        _this.$message.error('服务器内部错误')
		      });
		    },
		    watch_msg(key,num){
		      let _this=this;
		      _this.axios.get('/v2/user/get_msg_info',{params:{num:num}}).then(function(res) {
		        if(res.status=='200'){
		          if(res.data.code=='1'){
		            _this.msg.centerDialogVisible=true
		            _this.msg.msg_content=res.data.msg
		            _this.msg.list[key].status='1'
		          }else{
		            _this.$message.error(res.msg)
		          }
		        }else{
		          _this.$message.error('服务器内部错误')
		        }
		      }).catch(function(error) {
		        _this.$message.error('服务器内部错误')
		      });
		    }
		  }
	 }
</script>

<style scoped>
	/deep/ .el-upload-dragger{
	  border:0px;
	  width: 100%;
	  height: 100%;
	}
	.main {
	  min-height: calc(100vh - 330px);
	  width: 70%;
	  padding: 20px;
	  margin: 0 15%;
	  z-index: 100;
	  background-color: white;
	}

	h1 {
	  margin: 20px;
	}

	>>>.el-tabs {
	  width: 90%;
	  margin: 0 5%;
	}

	>>>.el-form-item__label {
	  padding-right: 30px;
	}

	.el-form-item .el-avatar {
	  width: 100px;
	  height: 100px;
	}

	.eidt .el-input {
	  margin: 10px 0;
	}

	.el-form-item p {
	  padding: 0;
	  margin: 0;
	  float: left;
	  font-size: medium;
	  font-weight: 600;
	}

	.eidtbtn {
	  padding: 0 40px;
	  line-height: 40px;
	}

	.eidt {
	  border: 1px dashed #606266;
	  padding: 20px;
	  overflow: hidden;
	  width: calc(100% - 42px);
	}

	/* 消息提醒 */
	>>>.el-alert {
	  line-height: 20px;
	  margin: 5px 0;
	}

	/* 分页 */
	.block {
	  margin: 30px 0;
	}
</style>



// WEBPACK FOOTER //
// src/view/infoBinding.vue